import {
  CreateEnvironmentCopyRequestRequest,
  CreateEnvironmentCopyRequestResponse,
  DeploymentRequestRestResource,
  UpdateEnvironmentCopyRequestRequest,
  UpdateEnvironmentCopyRequestResponse,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useCreateEnvironmentCopyRequest = () =>
  useRestResourceHook<
    CreateEnvironmentCopyRequestRequest,
    CreateEnvironmentCopyRequestResponse
  >((request) =>
    DeploymentRequestRestResource.createEnvironmentCopyRequest(request),
  );

export const useUpdateEnvironmentCopyRequest = () =>
  useRestResourceHook<
    UpdateEnvironmentCopyRequestRequest,
    UpdateEnvironmentCopyRequestResponse
  >((request) =>
    DeploymentRequestRestResource.updateEnvironmentCopyRequest(request),
  );
